import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { EthnicGroupProvider } from "../../context/EthnicGroupContext";

export const EthnicGroup = () => {
  return (
    <EthnicGroupProvider>
      <Overview />
    </EthnicGroupProvider>
  );
};

export const AddEthnicGroup = () => {
  return (
    <EthnicGroupProvider>
      <Add />
    </EthnicGroupProvider>
  );
};

export const EditEthnicGroup = () => {
  return (
    <EthnicGroupProvider>
      <Edit />
    </EthnicGroupProvider>
  );
};
